import { Feather } from "@expo/vector-icons";
import { StackScreenProps } from "@react-navigation/stack";
import {
  FlatActionList,
  FlatActionListItem,
  Page,
  useThemeProvider,
} from "@towersystems/roam-common-native";
import { useCallback, useMemo } from "react";
import { StockCountActionsRootScreenParamList } from "../../../../types";
import { useStockCountSearchContext } from "../../../../utilities/stock-count/hooks";
import { ScanMode } from "../../../../utilities/stock-count";

export type ScanModeSelectScreenProps = StackScreenProps<
  StockCountActionsRootScreenParamList,
  "ScanModeSelectScreen"
>;

export function ScanModeSelectScreen({
  navigation,
}: ScanModeSelectScreenProps) {
  const { colors } = useThemeProvider();
  const { scanMode, updateScanMode } = useStockCountSearchContext();

  const handleOnSelect = useCallback(
    (newScanMode: ScanMode) => {
      updateScanMode(newScanMode);
      navigation.goBack();
    },
    [navigation, updateScanMode]
  );

  const scanModes = ["quick", "slow"] as const;

  const items: FlatActionListItem[] = useMemo(() => {
    return (
      scanModes?.map((item) => {
        return {
          key: item,
          title: item,
          onPress: () => handleOnSelect(item),
          disabled: scanMode == item,
          componentRight: (icon) => {
            return scanMode == item ? (
              <Feather name="check" size={24} color={colors.primary} />
            ) : (
              icon
            );
          },
        };
      }) || []
    );
  }, [scanMode]);

  return (
    <Page title="Select Scan Mode">
      <FlatActionList items={items} />
    </Page>
  );
}
